import api from '@utils/api';
import config from '@/config';

const verificationQueryService = {
  // Get all queries with filtering and pagination
  getQueries: async (params = {}) => {
    return api.get('/vneid-queries', params);
  },

  // Get query by ID
  getQueryById: async (id) => {
    return api.get(`/vneid-queries/${id}`);
  },

  // Create new query
  createQuery: async (queryData) => {
    return api.post('/vneid-queries', queryData);
  },

  // Update query
  updateQuery: async (id, queryData) => {
    return api.put(`/vneid-queries/${id}`, queryData);
  },

  // Delete query
  deleteQuery: async (id) => {
    return api.delete(`/vneid-queries/${id}`);
  },

  // Get statistics
  getStatistics: async () => {
    return api.get('/vneid-queries/statistics');
  },

//   // Get configuration
//   getConfiguration: async () => {
//     return api.get('/vneid-queries/config');
//   },
// 
//   // Update configuration
//   updateConfiguration: async (configData) => {
//     return api.put('/vneid-queries/config', configData);
//   },
};

export default verificationQueryService;
